import styled from "styled-components";

const Dot = styled.span`
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: ${(p) => p.$size || "10px"};
  height: ${(p) => p.$size || "10px"};
  border-radius: 50%;
  background: ${(p) => (p.$online ? "#22c55e" : "#94a3b8")};
  border: 2px solid ${(p) => p.$borderColor || "#fff"};
  z-index: 2;
`;

export default function OnlineDot({ online, size, borderColor, style }) {
  return <Dot $online={online} $size={size} $borderColor={borderColor} style={style} />;
}
